var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVfcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Red_white",
    "data-name": "Logo / Red / white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179.622,
    height: 111.946,
    viewBox: "0 0 179.622 111.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_17",
    "data-name": "Clip 17",
    d: "M0,0H56.068V33.189H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VFC_logo_neg_vollton"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M19.122,0H.526C.158,0,0,.158,0,.527V32.662c0,.369.158.527.526.527h18.6c.37,0,.527-.158.527-.527V28.185c0-.369-.158-.527-.527-.527H6.585c-.369,0-.527-.158-.527-.527V19.65c0-.369.158-.527.527-.527H16.859c.368,0,.526-.158.526-.527V14.119c0-.369-.158-.527-.526-.527H6.585c-.369,0-.527-.158-.527-.527V6.058c0-.368.158-.526.527-.526H19.122c.37,0,.527-.158.527-.527V.527c0-.369-.158-.527-.527-.527",
    transform: "translate(76.738)",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M5.531,0H.526C.158,0,0,.158,0,.527V32.662c0,.369.158.527.526.527H5.531c.369,0,.527-.158.527-.527V.527C6.058.158,5.9,0,5.531,0",
    transform: "translate(63.672)",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M23.97,0H18.649a.472.472,0,0,0-.527.369l-5.215,19.07c-.106.369-.421,1.9-.527,2.318h-.264c-.105-.421-.421-2-.527-2.423L6.375.369A.472.472,0,0,0,5.848,0H.58C.21,0,0,.158,0,.421a4.721,4.721,0,0,0,.263,1l9.589,31.4a.473.473,0,0,0,.527.368h3.793a.472.472,0,0,0,.526-.368L24.339,1.212a4.451,4.451,0,0,0,.211-.79C24.55.158,24.339,0,23.97,0",
    transform: "translate(35.487)",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M21.336,0H16.384c-.37,0-.527.158-.527.527V7.165c0,4.162.21,11.749.316,13.013l-.21.053c-.158-.421-.9-2.318-1.106-2.687L5.427.263A.554.554,0,0,0,4.953,0H.527C.158,0,0,.158,0,.527V32.662c0,.369.158.527.527.527h5c.368,0,.526-.158.526-.527V26.13c0-4.162-.209-11.749-.316-13.013l.21-.053c.159.421.9,2.318,1.107,2.687l9.43,17.174a.554.554,0,0,0,.474.263h4.373c.369,0,.527-.158.527-.527V.527c0-.369-.158-.527-.527-.527",
    transform: "translate(101.392)",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M.589,1.869A4.377,4.377,0,0,0,.326.921L.045,0V2.286c.345-.011.544-.163.544-.417",
    transform: "translate(179.033 30.899)",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M23.971,33.189H18.649a.471.471,0,0,1-.526-.368l-1.581-5.532c-.055-.278-.286-.316-.526-.316H8.482c-.24,0-.471.038-.527.316L6.374,32.821a.471.471,0,0,1-.526.368H.58c-.363,0-.58-.157-.58-.421a1.7,1.7,0,0,1,.119-.475c.047-.139.1-.3.145-.473L9.852.369A.475.475,0,0,1,10.379,0h3.793A.47.47,0,0,1,14.7.369L24.006,30.9v2.287h-.017ZM12.222,10.905c-.052.207-.183.824-.31,1.421-.132.621-.269,1.262-.323,1.476l-1.579,6.111c-.023.079-.047.163-.073.248a3.941,3.941,0,0,0-.191.806c0,.284.233.474.579.474h3.846c.347,0,.58-.191.58-.474a4.707,4.707,0,0,0-.263-1L12.959,13.8c-.057-.2-.19-.9-.318-1.582-.109-.577-.212-1.122-.26-1.315Z",
    transform: "translate(155.073)",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M21.336,0H16.384c-.368,0-.527.158-.527.527V7.165c0,4.162.212,11.749.316,13.013l-.211.053c-.157-.421-.9-2.318-1.106-2.687L5.426.263A.552.552,0,0,0,4.953,0H.527C.158,0,0,.158,0,.527V32.662c0,.369.158.527.527.527H5.532c.368,0,.526-.158.526-.527V26.13c0-4.162-.212-11.749-.316-13.013l.21-.053c.157.421.9,2.318,1.106,2.687l9.43,17.174a.554.554,0,0,0,.474.263h4.373c.37,0,.527-.158.527-.527V.527c0-.369-.158-.527-.527-.527",
    transform: "translate(129.84)",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 38.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M12.96,14.224C9.9,12.8,6.848,12.011,6.848,9.325a3.847,3.847,0,0,1,3.794-3.8h.842c1.423,0,2.793.843,3.74,3.109.106.264.264.37.422.37a1.635,1.635,0,0,0,.633-.264l4.214-2.16c.212-.106.317-.212.317-.37a7.5,7.5,0,0,0-1-1.949C18.229,1.79,15.857,0,11.485,0h-.842C4.637,0,.843,3.845.843,9.325.843,15.54,5.427,17.7,9.589,19.7c2.844,1.318,5.636,2.371,5.636,5.215a3.843,3.843,0,0,1-3.792,3.793H9.325c-1.423,0-2.793-.842-3.74-3.106-.106-.264-.264-.37-.422-.37a1.637,1.637,0,0,0-.633.264L.317,27.657c-.21.106-.317.211-.317.37a7.479,7.479,0,0,0,1,1.949c1.58,2.477,3.952,4.267,8.324,4.267h2.107c6.005,0,9.8-3.846,9.8-9.326,0-6.374-4.268-8.85-8.271-10.693",
    transform: "translate(68.553 39.175)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M12.959,14.224C9.9,12.8,6.848,12.011,6.848,9.325a3.847,3.847,0,0,1,3.794-3.8h.843c1.422,0,2.791.843,3.74,3.109.105.264.263.37.421.37a1.626,1.626,0,0,0,.633-.264l4.214-2.16c.21-.106.316-.212.316-.37a7.465,7.465,0,0,0-1-1.949C18.228,1.79,15.857,0,11.485,0h-.843C4.636,0,.843,3.845.843,9.325.843,15.54,5.426,17.7,9.588,19.7c2.845,1.318,5.636,2.371,5.636,5.215a3.844,3.844,0,0,1-3.793,3.793H9.325c-1.422,0-2.793-.842-3.74-3.106-.106-.264-.264-.37-.421-.37a1.621,1.621,0,0,0-.633.264L.316,27.657c-.21.106-.316.211-.316.37a7.446,7.446,0,0,0,1,1.949c1.579,2.477,3.95,4.267,8.323,4.267h2.107c6.005,0,9.8-3.846,9.8-9.326,0-6.374-4.267-8.85-8.272-10.693",
    transform: "translate(92.049 39.175)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    d: "M25.918,0H21.494a.506.506,0,0,0-.475.317L14.013,17.068c-.158.37-.633,1.951-.738,2.371h-.158c-.105-.42-.527-2-.685-2.371L5.426.317A.507.507,0,0,0,4.952,0H.527C.157,0,0,.158,0,.526V32.663c0,.37.157.527.527.527h5c.368,0,.527-.158.527-.527V27.131c0-4.161-.474-11.484-.579-12.748l.21-.053a40.5,40.5,0,0,0,1.37,4.215l4.372,9.8a.51.51,0,0,0,.475.317h2.687a.508.508,0,0,0,.475-.317l4.373-9.8a40.348,40.348,0,0,0,1.37-4.215l.21.053c-.105,1.264-.579,8.587-.579,12.748v5.532c0,.37.158.527.527.527h4.951c.37,0,.527-.158.527-.527V.526c0-.368-.157-.526-.527-.526",
    transform: "translate(25.302 39.701)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_11",
    "data-name": "Fill 11",
    d: "M5.532,0h-5C.158,0,0,.158,0,.526V32.663c0,.37.158.527.527.527h5c.369,0,.527-.158.527-.527V.526C6.059.158,5.9,0,5.532,0",
    transform: "translate(58.754 39.701)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M21.336,0H16.383c-.368,0-.526.158-.526.526V7.165c0,4.162.21,11.748.316,13.012l-.21.053c-.158-.421-.9-2.319-1.107-2.688L5.426.264A.553.553,0,0,0,4.951,0H.526C.158,0,0,.158,0,.526V32.663c0,.37.158.527.526.527H5.531c.369,0,.527-.158.527-.527V26.13c0-4.161-.21-11.748-.316-13.013l.212-.053c.157.422.895,2.319,1.106,2.687l9.43,17.174a.554.554,0,0,0,.473.264h4.373c.368,0,.526-.158.526-.527V.526C21.862.158,21.7,0,21.336,0",
    transform: "translate(157.216 39.701)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    "data-name": "Fill 13",
    d: "M12.38,34.242H9.8a10.013,10.013,0,0,1-7.152-2.608A9.09,9.09,0,0,1,0,24.917V9.325A9.088,9.088,0,0,1,2.647,2.607,10.014,10.014,0,0,1,9.8,0H12.38c5.861,0,9.8,3.747,9.8,9.325V24.917C22.179,30.495,18.241,34.242,12.38,34.242ZM9.8,5.53a3.845,3.845,0,0,0-3.793,3.8V24.917A3.843,3.843,0,0,0,9.8,28.709H12.38a3.726,3.726,0,0,0,3.739-3.793V9.325a3.728,3.728,0,0,0-3.739-3.8Z",
    transform: "translate(129.611 39.175)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M5.532,0h-5C.158,0,0,.158,0,.526V32.663c0,.37.158.527.527.527h5c.368,0,.527-.158.527-.527V.526C6.059.158,5.9,0,5.532,0",
    transform: "translate(118.126 39.701)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    "data-name": "Fill 15",
    d: "M25.919,0H21.494a.5.5,0,0,0-.473.316L14.013,17.068c-.158.37-.632,1.95-.738,2.371h-.158c-.106-.421-.527-2-.686-2.371L5.425.316A.505.505,0,0,0,4.952,0H.527C.158,0,0,.158,0,.527V32.662c0,.369.158.527.527.527h5c.368,0,.527-.158.527-.527V27.131c0-4.162-.474-11.485-.58-12.75l.211-.052a40.147,40.147,0,0,0,1.37,4.215l4.373,9.8a.505.505,0,0,0,.474.316h2.687a.505.505,0,0,0,.473-.316l4.373-9.8a40.81,40.81,0,0,0,1.37-4.215l.21.052c-.106,1.265-.58,8.587-.58,12.75v5.531c0,.369.157.527.526.527h4.952c.37,0,.527-.158.527-.527V.527c0-.368-.158-.527-.527-.527",
    transform: "translate(58.702 0.527)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 0.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_17-2",
    "data-name": "Clip 17",
    d: "M0,0H56.068V33.189H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19-2",
    "data-name": "Group 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    "data-name": "Fill 16",
    d: "M19.124,27.658H6.585c-.368,0-.527-.158-.527-.527V.527C6.058.158,5.9,0,5.532,0h-5C.159,0,0,.158,0,.527V32.662c0,.369.159.527.527.527h18.6c.368,0,.527-.158.527-.527V28.185c0-.369-.159-.527-.527-.527",
    transform: "translate(36.417)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    "data-name": "Fill 18",
    d: "M19.123,0H.527C.157,0,0,.158,0,.527V32.662c0,.369.157.527.527.527h5c.368,0,.527-.158.527-.527V19.65c0-.368.158-.527.527-.527H16.858c.368,0,.527-.157.527-.526V14.119c0-.369-.158-.527-.527-.527H6.585c-.369,0-.527-.158-.527-.527V6.059c0-.369.158-.527.527-.527H19.123c.369,0,.527-.158.527-.527V.527c0-.368-.158-.527-.527-.527",
    transform: "translate(-0.038)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    d: "M5.532,0h-5C.159,0,0,.158,0,.527V32.662c0,.369.159.527.527.527h5c.369,0,.527-.158.527-.527V.527C6.059.158,5.9,0,5.532,0",
    transform: "translate(23.351 0.527)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_21",
    "data-name": "Fill 21",
    d: "M9.8,5.532H12.38c1.424,0,2.793.844,3.741,3.108.1.264.264.369.421.369a1.625,1.625,0,0,0,.633-.263l4.214-2.16c.21-.106.317-.21.317-.369a7.423,7.423,0,0,0-1-1.95C19.124,1.791,16.753,0,12.38,0H9.8C3.794,0,0,3.846,0,9.325V24.919c0,5.479,3.794,9.325,9.8,9.325H12.38c4.373,0,6.744-1.791,8.324-4.267a7.432,7.432,0,0,0,1-1.949c0-.158-.106-.263-.317-.369L17.175,25.5a1.627,1.627,0,0,0-.633-.264c-.158,0-.317.106-.421.37-.948,2.265-2.318,3.108-3.741,3.108H9.8a3.845,3.845,0,0,1-3.793-3.793V9.325A3.846,3.846,0,0,1,9.8,5.532",
    transform: "translate(100.055)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_22",
    "data-name": "Fill 22",
    d: "M25.92,0H21.494a.506.506,0,0,0-.475.316L14.013,17.068c-.158.37-.633,1.95-.736,2.371h-.159c-.105-.421-.527-2-.685-2.371L5.427.316A.507.507,0,0,0,4.952,0H.526C.158,0,0,.158,0,.527V32.662c0,.369.158.527.526.527H5.531c.37,0,.527-.158.527-.527V27.131c0-4.162-.474-11.485-.58-12.75l.211-.052a40.3,40.3,0,0,0,1.37,4.215l4.373,9.8a.506.506,0,0,0,.474.316h2.686a.508.508,0,0,0,.475-.316l4.372-9.8a40.3,40.3,0,0,0,1.37-4.215l.21.052c-.105,1.265-.579,8.587-.579,12.75v5.531c0,.369.158.527.526.527H25.92c.368,0,.526-.158.526-.527V.527c0-.368-.158-.527-.526-.527",
    transform: "translate(152.632 0.527)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_23",
    "data-name": "Fill 23",
    d: "M12.38,34.244H9.8a10.014,10.014,0,0,1-7.152-2.608A9.089,9.089,0,0,1,0,24.918V9.325A9.088,9.088,0,0,1,2.647,2.608,10.015,10.015,0,0,1,9.8,0H12.38c5.861,0,9.8,3.747,9.8,9.325V24.918C22.18,30.5,18.242,34.244,12.38,34.244ZM9.8,5.531A3.844,3.844,0,0,0,6.006,9.325V24.918A3.844,3.844,0,0,0,9.8,28.712H12.38a3.727,3.727,0,0,0,3.74-3.794V9.325a3.727,3.727,0,0,0-3.74-3.794Z",
    transform: "translate(125.027)",
    fill: "#ffffff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfcLogo);
export default __webpack_public_path__ + "static/media/vfc-logo.24457590.svg";
export { ForwardRef as ReactComponent };